module.exports = __webpack_public_path__ + "img/Bonuminzenjering.06e82b2e.png";